import React from 'react'

import AdminNavbar from '../components/Navbar/AdminNavbar'
import AdminCourse from '../components/Admin/AdminCourse'
import AdminPost from '../components/Admin/AdminPost'

const AdminCommentPage = () => {
  return (
    <>
    <AdminNavbar/>
    <AdminPost/>
    </>
  )
}

export default AdminCommentPage